import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { ServiceCRUD } from '../../../shared/crud/ServiceCRUD';
import { environment } from '../../../../environments/environment';

@Injectable()
export class VeiculosPedidosService extends ServiceCRUD {
  private baseUrlService: string;
  public carregando = true;

  constructor(public httpClient: HttpClient, router: Router, protected toastr: ToastrService) {
    super(httpClient, router);
    this.baseUrlService = environment.URL_API;
  }

  protected getURL(): string {
    return '';
  }

  public getDados(
    data_inicial?: any,
    data_final?: any,
    dealers?: any,
    grupo_economico?: any,
    chassi?: any,
    numeroPedidoDealer?: any,
    numeroPedidoFabrica?: any,
    status?: any,
    tipoPedido?: any): Observable<any> {
    return this.httpClient.get<any>(`${this.baseUrlService + '/veiculo/controlePedidos/'}`, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': JSON.parse(sessionStorage.getItem('currentUser')).token
      }),
      params: new HttpParams()
        .set('data_inicial', data_inicial.toString())
        .set('data_final', data_final.toString())
        .set('dealers', dealers.toString())
        .set('grupo_economico', grupo_economico.toString())
        .set('chassi', chassi.toString())
        .set('numero_pedido_dealer', numeroPedidoDealer.toString())
        .set('numero_pedido', numeroPedidoFabrica.toString())
        .set('status', status.toString())
        .set('tipo_pedido', tipoPedido ? tipoPedido.toString() : '')
    });
  }

}
